import React from 'react';
import { Link } from 'react-router-dom';
import R from "../../assests/rj.jpg";
import pc from "../../assests/plant_church.jpg";
import ec from "../../assests/educating_children.jpg";
import hc from "../../assests/humanatiran.jpg";

function Missions() {
  const missions = [
    {
      title: "Training Nationals",
      image: R,
      bg: "linear-gradient(135deg,#2c5f2e,#4a9e4d)",
      path: "/training-nationals",
    },
    {
      title: "Planting Churches",
      image: pc,
      bg: "linear-gradient(135deg,#1a4a7a,#2e7dc9)",
      path: "/planting-churches",
    },
    {
      title: "Educating Children",
      image: ec,
      bg: "linear-gradient(135deg,#7a3a00,#c96a1e)",
      path: "/educating-children",
    },
    {
      title: "Humanitarian Aid",
      image: hc,
      bg: "linear-gradient(135deg,#4a1a6e,#8e3fc9)",
      path: "/providing-humanitarian-aid",
    },
  ];

  return (
    <section className="missions" id="missions">
      <div className="section-header">
        <p className="section-eyebrow">What We Do</p>

        <h2 className="section-title script">
          Our Missions
        </h2>

        <div className="dots">
          • • • • • • • • •
        </div>
      </div>

      <div className="missions-grid">
        {missions.map((m, i) => (
          <div className="mission-card" key={i}>
            <div
              className="mission-img-placeholder"
              style={{ background: m.bg }}
            >
              <img
                src={m.image}
                alt={m.title}
                className="mission-image"
              />
            </div>

            <h3>{m.title}</h3>

            <Link
              to={m.path}
              className="btn-outline"
              style={{ display: "inline-block", textDecoration: "none" }}
            >
              READ MORE
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Missions;
